module.exports = "/assets/data/c641463989c520d1d473dd2d0d1e0f73-LS1.data.json";